module.exports = __webpack_public_path__ + "img/downloadTestCase.58af72f1.svg";